import API from "../api";
import { apiCallbackTreatment} from "../auxiliary/generalFunctions";

var api = new API();

export default class DebugController
{
    async debugging (string)
    {
        const response = await api.debug().debugging(string);

        return apiCallbackTreatment(response);
    }
}